var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-button',{attrs:{"size":"mini","type":"warning"},on:{"click":_vm.to}},[_vm._v("添加子权限")]),_c('GroupPushChildren',_vm._b({ref:"form",attrs:{"sup_this":_vm.sup_this}},'GroupPushChildren',_vm.$attrs,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }